import { useQuery } from "react-query";
import { AudienceService } from "../../../services/audience/audience.service";
import { filterFilterOptions } from "../../filter.util";
export var useAudienceSuggestions = function () {
    return useQuery('audienceSuggestions', AudienceService.getSuggestions);
};
export var useEstimatedAudienceSize = function (audience) {
    return useQuery(['audienceSize', audience === null || audience === void 0 ? void 0 : audience.filter], function () {
        if (!(audience === null || audience === void 0 ? void 0 : audience.filter)) {
            return Promise.resolve(0);
        }
        return AudienceService.getAudienceSize(audience.filter);
    });
};
export var useEstimatedMarketingAudienceSize = function (audience) {
    return useQuery(['marketingAudienceSize', audience === null || audience === void 0 ? void 0 : audience.filter], function () {
        if (!(audience === null || audience === void 0 ? void 0 : audience.filter)) {
            return Promise.resolve(0);
        }
        return AudienceService.getMarketingAudienceSize(audience.filter);
    });
};
/**
 * The full profile filter-option set (before the UI denylist). Shares the same react-query cache key
 * as {@link useAudienceProfileFilterOptions}, so it costs no extra request. Use this to RESOLVE a
 * rule's field label/operators — an audience (e.g. a template) can legitimately reference a field
 * that's hidden from the picker, and it must still render with its name rather than blank.
 */
export var useAllAudienceProfileFilterOptions = function () {
    var response = useQuery('audienceProfileFilterOptions', AudienceService.getProfileFilterOptions, {
        // 10 minutes
        staleTime: 10 * 60 * 1000
    });
    return response.data || [];
};
export var useAudienceProfileFilterOptions = function () {
    // Same cached query as above; the denylist only narrows what the field PICKER offers.
    return filterFilterOptions(useAllAudienceProfileFilterOptions());
};
export var useAudienceFilterOptions = function () {
    return useQuery('audienceFilterOptions', AudienceService.getFilterOptions, {
        // 10 minutes
        staleTime: 10 * 60 * 1000
    });
};
export var useAudienceMarketingFilterRules = function () {
    return useQuery('audienceMarketingFilterRules', AudienceService.getMarketingFilterRules, {
        // 10 minutes
        staleTime: 10 * 60 * 1000
    });
};
